import TimezoneDropdown from "app/components/TimezoneDropdown/TimezoneDropdown";
import React from "react";
type Props = {
  bookmarksOnly: boolean;
  favouritesOnly: boolean;
  currentTime: string;
  editingTimezone: boolean;
  onClickTimezone: (...args: Array<any>) => any;
  onChangeTimezone: (...args: Array<any>) => any;
  userTimezone: Record<string, any>;
};

const SearchEventsAndLeaguesTime: React.FC<Props> = ({
  bookmarksOnly,
  favouritesOnly,
  currentTime,
  editingTimezone,
  onClickTimezone,
  onChangeTimezone,
  userTimezone,
}) => {
  return (
    <div
      className={`search-events-and-leagues--time ${
        favouritesOnly || bookmarksOnly ? "hide" : ""
      }`}
    >
      {!editingTimezone ? (
        <React.Fragment>
          {currentTime}
          <span onClick={onClickTimezone} className="arrow-down" />
        </React.Fragment>
      ) : (
        <React.Fragment>
          {currentTime}
          <TimezoneDropdown
            onChange={onChangeTimezone}
            defaultValue={userTimezone}
          />
        </React.Fragment>
      )}
    </div>
  );
};

export default SearchEventsAndLeaguesTime;
